import { useState } from "react";

const insights = [
  { type: "企业分布", text: "苏州工业园区新增注册科技型企业287家，其中A轮以上融资企业占比16%，对公业务机会显著，建议优先部署客户经理团队", time: "15分钟前" },
  { type: "行业聚集", text: "武汉光谷生物医药产业集群新增企业46家，产业链上下游配套趋于完善，化学药与医疗器械子行业集中度环比提升12%", time: "28分钟前" },
  { type: "潜在客户", text: "成都天府新区近30天新增年营收超5000万企业23家，其中拟上市/拟融资企业8家，对公信贷潜在需求约6.8亿元", time: "42分钟前" },
  { type: "企业分布", text: "深圳南山区科技企业密度环比提升3.2%，新注册企业集中在人工智能与半导体领域，适合批量对公拓客推进", time: "1小时前" },
  { type: "行业聚集", text: "杭州余杭区电商及新零售产业链企业突破2,800家，直播电商、跨境贸易子行业增速领先，供应链金融需求旺盛", time: "2小时前" },
];

const opportunities = [
  { icon: "ri-building-2-line", name: "某新能源科技集团", tag: "高意向", location: "华东·常州", desc: "年营收规模42亿，拟新建3条产线，融资需求约3.5亿元，企业信用评级AA+，对公授信机会显著", time: "12分钟前" },
  { icon: "ri-flask-line", name: "某生物医药创新企业", tag: "接触中", location: "华南·深圳", desc: "B轮融资后现金流充裕，正筹备IPO，拟开立募集资金监管账户，综合金融需求约1.2亿", time: "28分钟前" },
  { icon: "ri-global-line", name: "某跨境物流集团华东总部", tag: "已触达", location: "华东·上海", desc: "跨境贸易结算规模年增65%，外汇避险、供应链金融、跨境资金池等综合业务需求旺盛", time: "1小时前" },
  { icon: "ri-cpu-line", name: "某半导体材料制造企业", tag: "深度洽谈", location: "华中·武汉", desc: "国产替代加速推进，产能扩张计划获批，设备采购贷款+流动资金贷款需求约2.8亿", time: "2小时前" },
  { icon: "ri-store-3-line", name: "某连锁商业集团总部", tag: "新机会", location: "西南·成都", desc: "全国门店扩张至580家，拟开展供应链金融+门店收单+员工代发等综合对公业务合作", time: "3小时前" },
];

const tagColors: Record<string, string> = {
  "高意向": "bg-emerald-100 text-emerald-700",
  "接触中": "bg-blue-100 text-blue-700",
  "已触达": "bg-amber-100 text-amber-700",
  "深度洽谈": "bg-violet-100 text-violet-700",
  "新机会": "bg-slate-100 text-slate-700",
};

export default function FSInsightsV2() {
  const [dataTab, setDataTab] = useState("全部洞察");
  const [bizTab, setBizTab] = useState("对公业务拓客");
  const dataTabs = ["全部洞察", "企业分布", "行业聚集", "潜在客户"];
  const bizTabs = ["对公业务拓客", "零售业务拓客"];
  const filteredInsights = dataTab === "全部洞察" ? insights : insights.filter(i => i.type === dataTab);

  return (
    <>
      {/* DATA INSIGHTS */}
      <section className="py-20 px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-end justify-between mb-10">
            <div>
              <span className="text-xs font-semibold text-cyan-600 tracking-widest uppercase mb-2 block">Data Insights</span>
              <h2 className="text-3xl font-bold text-slate-800">空间数据洞察看板</h2>
              <p className="text-slate-500 text-sm mt-1">多维空间数据融合分析，聚焦企业分布、行业集聚与潜在客户规模，实时洞察对公业务机会</p>
            </div>
            <div className="flex gap-1 bg-slate-100 rounded-xl p-1">
              {dataTabs.map(t => (
                <button key={t} onClick={() => setDataTab(t)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${dataTab === t ? "bg-white text-cyan-700 shadow-sm font-semibold" : "text-slate-500 hover:text-slate-700"}`}>{t}</button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-3 gap-6">
            {/* Left: stat cards + distribution + quality */}
            <div className="flex flex-col gap-4">
              {/* Stat cards in a 2-col sub-grid */}
              <div className="grid grid-cols-2 gap-4">
                {[
                  { icon: "ri-map-pin-2-line", value: "36", label: "覆盖省份", sub: "全国" },
                  { icon: "ri-building-4-line", value: "342", label: "覆盖城市", sub: "地级市" },
                  { icon: "ri-database-2-line", value: "8,600万+", label: "企业数据量", sub: "全量包含" },
                  { icon: "ri-refresh-line", value: "每日更新", label: "数据刷新", sub: "实时同步" },
                ].map(s => (
                  <div key={s.label} className="bg-slate-50 rounded-xl px-4 py-4 border border-slate-100 text-center">
                    <div className="w-10 h-10 rounded-xl bg-white border border-slate-100 flex items-center justify-center mx-auto mb-2">
                      <i className={`${s.icon} text-cyan-600 text-base`}></i>
                    </div>
                    <div className="text-xl font-bold text-slate-800">{s.value}</div>
                    <div className="text-xs text-slate-400">{s.label}</div>
                    <div className="text-xs text-slate-300">{s.sub}</div>
                  </div>
                ))}
              </div>
              {/* Distribution */}
              <div className="bg-slate-50 rounded-2xl p-5 border border-slate-100">
                <h4 className="text-slate-700 font-semibold text-sm mb-3">企业数据维度分布</h4>
                {[{type:"企业工商数据",pct:45,color:"bg-blue-400"},{type:"行业分类数据",pct:28,color:"bg-emerald-400"},{type:"经营指标数据",pct:18,color:"bg-amber-400"},{type:"区域空间数据",pct:9,color:"bg-violet-400"}].map(d => (
                  <div key={d.type} className="flex items-center gap-2 mb-2">
                    <span className="text-slate-600 text-xs w-24 flex-shrink-0">{d.type}</span>
                    <div className="flex-1 bg-slate-200 rounded-full h-2"><div className={`${d.color} rounded-full h-2`} style={{width:`${d.pct}%`}}></div></div>
                    <span className="text-slate-500 text-xs w-8 text-right">{d.pct}%</span>
                  </div>
                ))}
              </div>
              {/* Quality metrics */}
              <div className="bg-gradient-to-br from-[#0a1e3a] to-[#0d2a4a] rounded-2xl p-5 text-white">
                <div className="flex items-center gap-2 mb-3">
                  <i className="ri-pulse-line text-cyan-300 text-sm"></i>
                  <span className="text-white/80 text-xs font-medium">数据质量评分</span>
                </div>
                <div className="space-y-2">
                  {[{label:"完整性",value:"96%",color:"text-emerald-300"},{label:"准确性",value:"93%",color:"text-blue-300"},{label:"时效性",value:"99%",color:"text-amber-300"}].map(m => (
                    <div key={m.label} className="flex items-center justify-between bg-white/10 rounded-lg px-3 py-2">
                      <span className="text-white/70 text-xs">{m.label}</span>
                      <span className={`text-sm font-bold ${m.color}`}>{m.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right: highlights + feed */}
            <div className="lg:col-span-2 flex flex-col gap-6">
              {/* 3 highlight cards */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-slate-50 rounded-2xl p-5 border border-slate-100">
                  <h4 className="text-slate-700 font-semibold text-sm mb-1">区域企业分布</h4>
                  <p className="text-slate-400 text-xs mb-2">实时监测各行政区域企业动态</p>
                  <div className="text-lg font-bold text-cyan-600">860万+</div>
                  <div className="text-xs text-slate-400">覆盖企业</div>
                </div>
                <div className="bg-slate-50 rounded-2xl p-5 border border-slate-100">
                  <h4 className="text-slate-700 font-semibold text-sm mb-1">行业聚集分布</h4>
                  <p className="text-slate-400 text-xs mb-2">量化分析细分行业空间集聚</p>
                  <div className="text-lg font-bold text-cyan-600">47个</div>
                  <div className="text-xs text-slate-400">重点行业</div>
                </div>
                <div className="bg-slate-50 rounded-2xl p-5 border border-slate-100">
                  <h4 className="text-slate-700 font-semibold text-sm mb-1">潜在客户规模</h4>
                  <p className="text-slate-400 text-xs mb-2">构建对公潜在客户评分模型</p>
                  <div className="text-lg font-bold text-cyan-600">120万+</div>
                  <div className="text-xs text-slate-400">潜在法人客户</div>
                </div>
              </div>

              {/* Insight feed */}
              <div className="bg-slate-50 rounded-2xl border border-slate-100 overflow-hidden">
                <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
                  <span className="font-semibold text-slate-700 text-sm">实时空间数据洞察</span>
                  <span className="text-xs text-slate-400">{filteredInsights.length} 条最新洞察</span>
                </div>
                <div className="divide-y divide-slate-100">
                  {filteredInsights.map(item => (
                    <div key={item.text.substring(0,20)} className="px-5 py-4 hover:bg-white transition-colors cursor-pointer">
                      <div className="flex items-start gap-3">
                        <span className="text-xs bg-cyan-50 text-cyan-700 border border-cyan-100 px-2 py-0.5 rounded-full flex-shrink-0 mt-0.5">{item.type}</span>
                        <div className="flex-1 min-w-0">
                          <p className="text-slate-600 text-sm">{item.text}</p>
                        </div>
                        <span className="text-xs text-slate-400 flex-shrink-0 whitespace-nowrap"><i className="ri-time-line mr-1"></i>{item.time}</span>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="px-5 py-3 border-t border-slate-200 bg-white flex items-center justify-between">
                  <span className="text-xs text-slate-400">数据实时更新 · 每30秒刷新</span>
                  <button className="text-xs text-cyan-600 hover:text-cyan-700 font-medium cursor-pointer whitespace-nowrap flex items-center gap-1"><i className="ri-external-link-line"></i>查看全部洞察</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BUSINESS DEVELOPMENT */}
      <section className="py-20 px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-end justify-between mb-10">
            <div>
              <span className="text-xs font-semibold text-cyan-600 tracking-widest uppercase mb-2 block">Business Development</span>
              <h2 className="text-3xl font-bold text-slate-800">对公业务拓客 · 企业客户精准触达</h2>
              <p className="text-slate-500 text-sm mt-1">基于企业全量数据与空间洞察，精准定位高价值法人客户，驱动对公业务高效增长</p>
            </div>
            <div className="flex gap-1 bg-white rounded-xl p-1 border border-slate-200">
              {bizTabs.map(t => (
                <button key={t} onClick={() => setBizTab(t)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${bizTab === t ? "bg-white text-cyan-700 shadow-sm font-semibold" : "text-slate-500 hover:text-slate-700"}`}>{t}</button>
              ))}
            </div>
          </div>

          {/* Corporate data */}
          {bizTab === "对公业务拓客" && (
          <div className="grid grid-cols-3 gap-6">
            <div className="flex flex-col gap-4">
              <div className="bg-gradient-to-br from-[#0a1e3a] to-[#0d2a4a] rounded-2xl p-5 text-white">
                <div className="flex items-center gap-2 mb-4">
                  <i className="ri-pulse-line text-cyan-300 text-sm"></i>
                  <span className="text-white/80 text-xs font-medium">对公拓客总览</span>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  {[{value:"1,240",label:"本月新增线索",color:"text-cyan-300"},{value:"386",label:"深度跟进中",color:"text-blue-300"},{value:"92",label:"本月落地",color:"text-emerald-300"},{value:"22%",label:"转化率提升",color:"text-amber-300"}].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-xl p-3">
                      <div className={`text-xl font-bold ${s.color}`}>{s.value}</div>
                      <div className="text-white/50 text-xs mt-0.5">{s.label}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="bg-white rounded-2xl p-5 border border-slate-100 flex-1">
                <h4 className="text-slate-700 font-semibold text-sm mb-3">对公拓客流程</h4>
                {[{num:"01",title:"企业画像构建",sub:"多维数据融合"},{num:"02",title:"目标客户筛选",sub:"产业链精准匹配"},{num:"03",title:"智能触达策略",sub:"关系路径分析"},{num:"04",title:"需求深度挖掘",sub:"资金流经营分析"},{num:"05",title:"业务落地转化",sub:"全流程追踪闭环"}].map((step,i) => (
                  <div key={step.num} className="flex items-center gap-3 mb-3 last:mb-0">
                    <div className="w-8 h-8 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center text-xs font-bold">{step.num}</div>
                    <div>
                      <div className="text-slate-700 text-sm font-medium">{step.title}</div>
                      <div className="text-slate-400 text-xs">{step.sub}</div>
                    </div>
                    {i < 4 && <div className="ml-auto text-slate-300 text-xs">›</div>}
                  </div>
                ))}
              </div>
            </div>
            <div className="col-span-2 bg-white rounded-2xl border border-slate-100 overflow-hidden flex flex-col">
              <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
                <span className="font-semibold text-slate-700 text-sm">对公业务机会列表</span>
                <span className="text-xs text-slate-400">5 条业务机会</span>
              </div>
              <div className="divide-y divide-slate-100 flex-1">
                {opportunities.map(op => (
                  <div key={op.name} className="px-5 py-4 hover:bg-slate-50 transition-colors cursor-pointer">
                    <div className="flex items-start gap-3">
                      <div className="w-9 h-9 rounded-lg bg-indigo-50 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className={`${op.icon} text-indigo-600 text-sm`}></i>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 flex-wrap">
                          <span className="text-slate-800 text-sm font-medium">{op.name}</span>
                          <span className={`text-xs border px-2 py-0.5 rounded-full ${tagColors[op.tag] || "bg-slate-100 text-slate-600"}`}>{op.tag}</span>
                        </div>
                        <div className="text-xs text-slate-400 mt-0.5">{op.location}</div>
                        <p className="text-slate-500 text-xs mt-1 leading-relaxed">{op.desc}</p>
                      </div>
                      <span className="text-xs text-slate-400 flex-shrink-0 whitespace-nowrap"><i className="ri-time-line mr-1"></i>{op.time}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="px-5 py-3 border-t border-slate-200 bg-white flex items-center justify-between">
                <span className="text-xs text-slate-400">数据实时更新 · 每30秒刷新</span>
                <button className="text-xs text-cyan-600 hover:text-cyan-700 font-medium cursor-pointer whitespace-nowrap flex items-center gap-1"><i className="ri-external-link-line"></i>查看全部</button>
              </div>
            </div>
          </div>
          )}

          {/* Retail data */}
          {bizTab === "零售业务拓客" && (
          <div className="grid grid-cols-3 gap-6">
            <div className="flex flex-col gap-4">
              <div className="bg-gradient-to-br from-[#0a1e3a] to-[#0d2a4a] rounded-2xl p-5 text-white">
                <div className="flex items-center gap-2 mb-4">
                  <i className="ri-pulse-line text-cyan-300 text-sm"></i>
                  <span className="text-white/80 text-xs font-medium">零售拓客总览</span>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  {[{value:"8,652",label:"本月新增客群",color:"text-cyan-300"},{value:"1,240",label:"高净值识别",color:"text-blue-300"},{value:"420亿",label:"财富管理规模",color:"text-emerald-300"},{value:"14%",label:"NPS提升",color:"text-amber-300"}].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-xl p-3">
                      <div className={`text-xl font-bold ${s.color}`}>{s.value}</div>
                      <div className="text-white/50 text-xs mt-0.5">{s.label}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="bg-white rounded-2xl p-5 border border-slate-100 flex-1">
                <h4 className="text-slate-700 font-semibold text-sm mb-3">零售拓客流程</h4>
                {[{num:"01",title:"客群画像构建",sub:"人口消费融合"},{num:"02",title:"高净值识别",sub:"财富潜力评分"},{num:"03",title:"精准触达策略",sub:"多渠道联动"},{num:"04",title:"需求深度挖掘",sub:"产品匹配模型"},{num:"05",title:"业务落地转化",sub:"全流程追踪闭环"}].map((step,i) => (
                  <div key={step.num} className="flex items-center gap-3 mb-3 last:mb-0">
                    <div className="w-8 h-8 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center text-xs font-bold">{step.num}</div>
                    <div>
                      <div className="text-slate-700 text-sm font-medium">{step.title}</div>
                      <div className="text-slate-400 text-xs">{step.sub}</div>
                    </div>
                    {i < 4 && <div className="ml-auto text-slate-300 text-xs">›</div>}
                  </div>
                ))}
              </div>
            </div>
            <div className="col-span-2 bg-white rounded-2xl border border-slate-100 overflow-hidden flex flex-col">
              <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
                <span className="font-semibold text-slate-700 text-sm">零售业务机会列表</span>
                <span className="text-xs text-slate-400">5 条业务机会</span>
              </div>
              <div className="divide-y divide-slate-100 flex-1">
                {[
                  {icon:"ri-user-star-line",name:"某高净值客户家族信托",tag:"高意向",loc:"华东·上海",desc:"可投资资产超5,000万元，拟设立家族信托+私人银行综合服务方案，企业主财富管理潜力显著",time:"8分钟前"},
                  {icon:"ri-hand-coin-line",name:"某科技企业高管股权激励",tag:"接触中",loc:"华南·深圳",desc:"上市公司高管持股解禁期临近，股权资产管理+税务筹划+再投资综合需求约3,000万元",time:"25分钟前"},
                  {icon:"ri-home-heart-line",name:"某高端社区按揭需求群",tag:"已触达",loc:"华东·杭州",desc:"城西高端社区集中交付期，批量按揭贷款+装修分期需求约2.6亿元，可开展社区精准营销",time:"50分钟前"},
                  {icon:"ri-funds-line",name:"某跨境高净值客群",tag:"深度洽谈",loc:"华南·广州",desc:"外贸企业主群体年结汇量超2亿美元，外汇避险+跨境理财+子女海外教育金融综合需求",time:"1.5小时前"},
                  {icon:"ri-service-line",name:"某养老社区综合金融",tag:"新机会",loc:"西南·成都",desc:"CCRC养老社区二期即将开放，养老金融服务+年金保险+医疗健康保险综合合作机会",time:"2.5小时前"},
                ].map(op => (
                  <div key={op.name} className="px-5 py-4 hover:bg-slate-50 transition-colors cursor-pointer">
                    <div className="flex items-start gap-3">
                      <div className="w-9 h-9 rounded-lg bg-indigo-50 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className={`${op.icon} text-indigo-600 text-sm`}></i>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 flex-wrap">
                          <span className="text-slate-800 text-sm font-medium">{op.name}</span>
                          <span className={`text-xs border px-2 py-0.5 rounded-full ${tagColors[op.tag] || "bg-slate-100 text-slate-600"}`}>{op.tag}</span>
                        </div>
                        <div className="text-xs text-slate-400 mt-0.5">{op.loc}</div>
                        <p className="text-slate-500 text-xs mt-1 leading-relaxed">{op.desc}</p>
                      </div>
                      <span className="text-xs text-slate-400 flex-shrink-0 whitespace-nowrap"><i className="ri-time-line mr-1"></i>{op.time}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="px-5 py-3 border-t border-slate-200 bg-white flex items-center justify-between">
                <span className="text-xs text-slate-400">数据实时更新 · 每30秒刷新</span>
                <button className="text-xs text-cyan-600 hover:text-cyan-700 font-medium cursor-pointer whitespace-nowrap flex items-center gap-1"><i className="ri-external-link-line"></i>查看全部</button>
              </div>
            </div>
          </div>
          )}
        </div>
      </section>
    </>
  );
}
